import { useState } from "react";
import { Link } from "react-router-dom";

interface NavProps {
  onContactOpen: () => void;
}

const navLinks = [
  { label: "About", to: "/about" },
  { label: "Case Studies", to: "/case-studies" },
  { label: "Blog", to: "/blog" },
];

export default function Nav({ onContactOpen }: NavProps) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 border-b border-border bg-[rgba(11,11,15,0.85)] backdrop-blur-xl"
    >
      <nav
        aria-label="Main navigation"
        className="editorial-container flex items-center justify-between py-4"
      >
        {/* Logo */}
        <Link
          to="/"
          aria-label="Zero to Ten — home"
          className="font-mono text-lg text-accent tracking-tight"
        >
          0→10
        </Link>

        {/* Desktop nav links */}
        <div className="hidden items-center gap-6 md:flex">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="text-small font-medium text-foreground-muted transition-colors duration-200 hover:text-accent"
            >
              {link.label}
            </Link>
          ))}

          {/* CTA */}
          <button
            onClick={onContactOpen}
            className="group inline-flex items-center gap-2 font-body text-cta uppercase text-accent transition-all duration-300 hover:gap-4"
          >
            START BUILDING
            <span
              aria-hidden="true"
              className="inline-block transition-transform duration-300 group-hover:translate-x-0.5"
            >
              →
            </span>
          </button>
        </div>

        {/* Mobile menu button */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          className="flex flex-col gap-1.5 md:hidden"
        >
          <span className={`block h-0.5 w-5 bg-foreground transition-all duration-300 ${menuOpen ? "translate-y-2 rotate-45" : ""}`} />
          <span className={`block h-0.5 w-5 bg-foreground transition-all duration-300 ${menuOpen ? "opacity-0" : ""}`} />
          <span className={`block h-0.5 w-5 bg-foreground transition-all duration-300 ${menuOpen ? "-translate-y-2 -rotate-45" : ""}`} />
        </button>
      </nav>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="border-t border-border bg-[rgba(11,11,15,0.95)] backdrop-blur-xl md:hidden">
          <div className="editorial-container flex flex-col gap-4 py-6">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setMenuOpen(false)}
                className="text-body font-medium text-foreground-muted transition-colors duration-200 hover:text-accent"
              >
                {link.label}
              </Link>
            ))}
            <button
              onClick={() => { setMenuOpen(false); onContactOpen(); }}
              className="group mt-2 inline-flex items-center gap-2 font-body text-cta uppercase text-accent transition-all duration-300 hover:gap-4"
            >
              START BUILDING
              <span aria-hidden="true" className="inline-block transition-transform duration-300 group-hover:translate-x-0.5">→</span>
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
